module.exports = __webpack_public_path__ + "static/img/sgwu.00bbb85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sgwu.png
// module id = tOYo
// module chunks = 0